import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Reveal } from "@/components/motion";
import usePageMeta from "@/hooks/usePageMeta";
import { BRAND, BLOG_POSTS } from "@/data/content";

export default function Blog() {
  usePageMeta(
    `Resources & Insights — ${BRAND.name}`,
    "Practical wisdom on export-import, MSME growth and AI adoption — from 40 years on the global trade frontline."
  );

  return (
    <div data-testid="blog-page">
      <PageHero
        kicker="Resources & Insights"
        lines={["Wisdom, Written", "Down."]}
        description="Practical notes on global trade, MSME growth and honest AI adoption — the same advice I give my coaching clients, free to read."
        accent="gold"
      />

      <section className="pb-28 pt-8 md:pb-36">
        <div className="mx-auto max-w-6xl px-6">
          <div className="grid gap-6 md:grid-cols-2">
            {BLOG_POSTS.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 2) * 0.12} className="h-full">
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-[#1E3A5F] bg-[#0A2540] p-9 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-2 hover:border-gold/50 hover:shadow-[0_20px_40px_-15px_rgba(201,162,39,0.2)]"
                >
                  <div className="flex items-center justify-between">
                    <span className="kicker !text-[10px] text-gold">{p.category}</span>
                    <ArrowUpRight className="h-5 w-5 text-slate-600 transition-colors group-hover:text-gold" strokeWidth={1.5} />
                  </div>
                  <h2 className="mt-5 font-serif text-2xl leading-snug text-white transition-colors group-hover:text-gold-light">
                    {p.title}
                  </h2>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-400">{p.excerpt}</p>
                  <div className="mt-7 flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-slate-500">
                    <span>{p.date}</span>
                    <span className="h-1 w-1 rounded-full bg-slate-600" />
                    <span>{p.readTime}</span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        kicker="Enjoyed Reading?"
        title="Get advice tailored to your business."
        subtitle="Articles are general. Your situation isn't. Let's talk about yours."
      />
    </div>
  );
}
